// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".create-resource-container .subtype-banner[data-v-1e92eeea]{min-height:80px;padding:10px}", ""]);
// Exports
module.exports = exports;
